import { RemoteTagManager } from "divine-binary-tags";
export const ChunkTags = new RemoteTagManager("chunk-tags");
